<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col>
          {{contract.contractName}}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p>{{contract.area.name}}</p>
        </v-col>
        <v-col>
          {{contract.project ? contract.project.name : ''}}
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-divider/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-autocomplete
            v-model="currency"
            :items="contractCurrencies"
            outlined
            hide-details
            dense
            label="Currencies"
            return-object
            item-value="key"
            :style="{ marginTop: '5px' }"
          >
            <template v-slot:selection="{ item }">
              {{ item.key }}
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content :key="item.key">
                <v-list-item-title>{{ item.key }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { DEFAULT_CONTRACT } from '@/helpers'

export default {
  name: 'ContractMenu',
  props: {
    contract: {
      type: Object,
      default: () => DEFAULT_CONTRACT
    }
  },
  data () {
    return {
      currency: this.contract.chosenCurrency || {}
    }
  },
  computed: {
    contractCurrencies () {
      return this.contract.currencies
    },
    contractCurrency () {
      return this.contract.chosenCurrency
    }
  },
  watch: {
    currency (v) {
      this.$eventBus.$emit('SET_CURRENCY', v)
    },
    contractCurrency (v, p) {
      if (this.currency.key !== v.key) this.currency = v
    }
  }
}
</script>
